import { render, staticRenderFns } from "./meetingRecordDetail.vue?vue&type=template&id=3b8be576&"
import script from "./meetingRecordDetail.vue?vue&type=script&lang=js&"
export * from "./meetingRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./meetingRecordDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports